import React from 'react';
import PageSection from 'components/PageSection';
import { useAPI } from 'api';
import DataTable from 'components/DataTable';
import { UserGroup } from 'types';
import { useOrgContext } from 'components/OrgContextProvider';

export default function WorkspaceUserGroupSettings() {
	const api = useAPI();

	const ctx = useOrgContext();

	const [workspaceUserGroups, setWorkspaceUserGroups] = React.useState<UserGroup[]>([]);
	const [selectedUserGroups, setSelectedUserGroups] = React.useState<UserGroup[]>([]);

	const loadWorkspaceUserGroups = () => {
		api.get<UserGroup[]>(`${ctx?.apiBaseWorkspace}/overrides/firewall/usergroups`)
		.then(json => setWorkspaceUserGroups(json));
	};

	const selectUserGroup = (userGroup: UserGroup) => {
		setSelectedUserGroups([...selectedUserGroups, userGroup]);
	};

	const deselectUserGroup = (userGroup: UserGroup) => {
		setSelectedUserGroups(selectedUserGroups.filter(c => c.id !== userGroup.id));
	};

	const makeSelectedUserGroupsAvailable = () => {
		api.put(`${ctx?.apiBaseWorkspace}/overrides/firewall/usergroups/availability`, selectedUserGroups.reduce((acc, userGroup) => ({ ...acc, [userGroup.id]: 'available' }), {}))
		.then(() => loadWorkspaceUserGroups());
	};

	const makeSelectedUserGroupsUnavailable = () => {
		api.put(`${ctx?.apiBaseWorkspace}/overrides/firewall/usergroups/availability`, selectedUserGroups.reduce((acc, userGroup) => ({ ...acc, [userGroup.id]: 'unavailable' }), {}))
		.then(() => loadWorkspaceUserGroups());
	};

	React.useEffect(() => {
		loadWorkspaceUserGroups();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div>
			<PageSection level={3} title="User Groups">
				<p>User Groups for workspace '{ctx?.workspace?.name}'</p>

				<p>
					<button onClick={makeSelectedUserGroupsAvailable}>Make Selected Available</button>
					<button onClick={makeSelectedUserGroupsUnavailable}>Make Selected Unavailable</button>
				</p>

				<DataTable<UserGroup>
					columns={[
						{
							label: '',
							key: 'id',
							render: (userGroup) => <input type="checkbox" checked={selectedUserGroups.some(c => c.id === userGroup.id)} onChange={() => selectedUserGroups.some(c => c.id === userGroup.id) ? deselectUserGroup(userGroup) : selectUserGroup(userGroup)} />
						},
						{ label: 'Name', key: 'name' },
						{ label: 'Availability', key: 'availability' }
					]}
					data={workspaceUserGroups}
				/>
			</PageSection>
		</div>
	);
}
